import React from 'react';
import { Helmet } from 'react-helmet';
import Button from '../components/ui/Button';
import { Mail, Clock, MapPin } from 'lucide-react';
export default function Contact() {
  return <main className="min-h-screen bg-white" data-id="element-418">
      <Helmet data-id="element-419">
        <title data-id="element-420">Contact Medico-Legal Psychiatry – Expert Witness Services</title>
        <meta name="description" content="Contact Medico-Legal Psychiatry. Email Dr. Imtiaz Syed for medico-legal assessments, expert witness reports & psychiatric evaluations across the UK." data-id="element-421" />
        <meta name="keywords" content="Contact Medico-Legal Psychiatry, Expert Witness Psychiatrist UK, Legal Psychiatric Assessment, Dr Imtiaz Syed Contact, Independent Psychiatric Reports UK" data-id="element-422" />

        {/* Open Graph tags for WhatsApp/social media */}
        <meta property="og:type" content="website" data-id="element-423" />
        <meta property="og:title" content="Contact Medico-Legal Psychiatry – Expert Witness Services" data-id="element-424" />
        <meta property="og:description" content="Contact Dr. Imtiaz Syed for expert psychiatric assessments and reports for legal proceedings. Email: enquiries@medicolegal-psychiatry.co.uk" data-id="element-425" />
        <meta property="og:url" content="https://medicolegal-psychiatry.co.uk/contact" data-id="element-426" />
        <meta property="og:image" content="https://uploadthingy.s3.us-west-1.amazonaws.com/u9Nr778koLscH9uY6kZjEn/01._Hero_Image.png" data-id="element-427" />

        {/* Twitter Card tags */}
        <meta name="twitter:card" content="summary_large_image" data-id="element-428" />
        <meta name="twitter:title" content="Contact Medico-Legal Psychiatry – Expert Witness Services" data-id="element-429" />
        <meta name="twitter:description" content="Contact Dr. Imtiaz Syed for expert psychiatric assessments and reports for legal proceedings." data-id="element-430" />
        <meta name="twitter:image" content="https://uploadthingy.s3.us-west-1.amazonaws.com/u9Nr778koLscH9uY6kZjEn/01._Hero_Image.png" data-id="element-431" />

        <script type="application/ld+json" data-id="element-432">
          {`
            {
              "@context": "https://schema.org",
              "@type": "ContactPage",
              "name": "Contact Medico-Legal Psychiatry",
              "description": "Contact Dr. Imtiaz Syed for expert psychiatric assessments and reports for legal proceedings. Remote or in-person services available nationwide.",
              "mainEntity": {
                "@type": "Organization",
                "name": "Medico-Legal Psychiatry",
                "contactPoint": {
                  "@type": "ContactPoint",
                  "contactType": "customer service",
                  "email": "enquiries@medicolegal-psychiatry.co.uk",
                  "availableLanguage": ["English", "Urdu", "Hindi", "Punjabi"]
                },
                "openingHoursSpecification": [
                  {
                    "@type": "OpeningHoursSpecification",
                    "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
                    "opens": "09:00",
                    "closes": "17:00"
                  },
                  {
                    "@type": "OpeningHoursSpecification",
                    "dayOfWeek": "Saturday",
                    "opens": "09:00",
                    "closes": "13:00"
                  }
                ]
              }
            }
          `}
        </script>
      </Helmet>
      {/* Hero Section */}
      <section className="bg-primary text-white py-10 pt-24 md:pt-28" data-id="element-433">
        <div className="container mx-auto px-4" data-id="element-434">
          <h1 className="text-3xl md:text-4xl lg:text-5xl font-serif font-bold mb-4 text-center" data-id="element-435">
            Contact Medico-Legal Psychiatry
          </h1>
          <p className="text-xl max-w-3xl mx-auto text-center" data-id="element-436">
            Get in Touch for Expert Psychiatric Assessments
          </p>
        </div>
      </section>
      {/* Main Content */}
      <section className="py-12" data-id="element-437">
        <div className="container mx-auto px-4" data-id="element-438">
          <div className="max-w-3xl mx-auto mb-12" data-id="element-439">
            <p className="text-slate-dark text-lg mb-6" data-id="element-440">
              We've made it easy for you to reach us. Choose the method that
              works best for you:
            </p>
            <ul className="space-y-6 mb-8" data-id="element-441">
              <li className="flex items-start" data-id="element-442">
                <div className="bg-primary rounded-full p-2 text-white mr-4" data-id="element-443">
                  <Mail className="h-6 w-6" data-id="element-444" />
                </div>
                <div data-id="element-445">
                  <h3 className="text-xl font-serif font-bold text-primary mb-1" data-id="element-446">
                    Direct Email
                  </h3>
                  <p className="text-slate-dark mb-2" data-id="element-447">
                    For detailed inquiries and to send instruction bundles, you
                    can email us directly:
                  </p>
                  <a href="mailto:enquiries@medicolegal-psychiatry.co.uk" className="text-primary hover:text-secondary transition-colors" data-id="element-448">
                    enquiries@medicolegal-psychiatry.co.uk
                  </a>
                </div>
              </li>
              <li className="flex items-start" data-id="element-449">
                <div className="bg-primary rounded-full p-2 text-white mr-4" data-id="element-450">
                  <Clock className="h-6 w-6" data-id="element-451" />
                </div>
                <div data-id="element-452">
                  <h3 className="text-xl font-serif font-bold text-primary mb-1" data-id="element-453">
                    Our Hours
                  </h3>
                  <p className="text-slate-dark mb-2" data-id="element-454">
                    Our team is available to process your messages and
                    coordinate discussions during:
                  </p>
                  <ul className="space-y-1 text-slate-dark" data-id="element-455">
                    <li data-id="element-456">
                      Monday to Friday: 9:00 AM to 5:00 PM (GMT/BST) (excluding
                      Bank Holidays)
                    </li>
                    <li data-id="element-457">Saturdays: 9:00 AM to 1:00 PM (GMT/BST)</li>
                    <li data-id="element-458">Sundays: Closed</li>
                  </ul>
                  <p className="text-slate mt-2" data-id="element-459">
                    Messages received outside of these hours will be addressed
                    promptly on the next working day.
                  </p>
                </div>
              </li>
              <li className="flex items-start" data-id="element-460">
                <div className="bg-primary rounded-full p-2 text-white mr-4" data-id="element-461">
                  <MapPin className="h-6 w-6" data-id="element-462" />
                </div>
                <div data-id="element-463">
                  <h3 className="text-xl font-serif font-bold text-primary mb-1" data-id="element-464">
                    Accessibility and Flexibility
                  </h3>
                  <p className="text-slate-dark" data-id="element-465">
                    Dr. Syed offers exceptional flexibility to accommodate your
                    needs and those of your clients. He can conduct remote
                    assessments across all regions of the UK. For your
                    convenience, in-person assessments can also be arranged, and
                    Dr. Syed is available for prison visits, care home visits,
                    and court attendance when required.
                  </p>
                </div>
              </li>
            </ul>
            <p className="text-slate-dark text-lg mb-6" data-id="element-466">
              We look forward to partnering with you to provide the expert
              psychiatric insights your cases require.
            </p>
          </div>
          {/* Email Contact Section (Replacing Form) */}
          <div className="max-w-2xl mx-auto bg-white rounded-lg shadow-md p-8 text-center" data-id="element-467">
            <h2 className="text-2xl font-serif font-bold text-primary mb-6" data-id="element-468">
              Contact Us Directly
            </h2>
            <div className="mb-8" data-id="element-469">
              <p className="text-slate-dark text-lg mb-4" data-id="element-470">
                For all inquiries regarding medico-legal assessments, expert
                witness services, or to discuss your specific case requirements,
                please email us directly. We aim to respond to all messages
                within 24 hours during business days.
              </p>
              <p className="text-slate-dark text-lg mb-6" data-id="element-471">
                Please include your name, contact information, and a brief
                description of your inquiry to help us assist you more
                efficiently.
              </p>
            </div>
            <div className="flex justify-center" data-id="element-472">
              <Button variant="primary" size="lg" href="mailto:enquiries@medicolegal-psychiatry.co.uk?subject=Medico-Legal%20Inquiry" data-id="element-473">
                <Mail className="h-5 w-5 mr-2" data-id="element-474" />
                Email Us Now
              </Button>
            </div>
          </div>
        </div>
      </section>
    </main>;
}